<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="area_title">
      <h1>{{ joinInPage.title }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ navbar.home }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="is-link" @click="onBack">{{ navbar.joinIn }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeNameText !== ''">
            {{ activeNameText }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="area_cation">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="joinInPage.tabs[0]" name="1">
          <div class="zp_wrap">
            <h2>{{ recruitmentInformation.titleOne }}</h2>
            <div v-html="$convertPxToRem(recruitmentInformation.contentOne)"></div>
            <el-table :data="tableData" border style="width: 100%;margin-top:50px">
              <el-table-column :prop="`${currentLang.prefix}name`" :label="recruitmentInformation.tableHead[0]" width="230" align="center"></el-table-column>
              <el-table-column :prop="`${currentLang.prefix}place`" :label="recruitmentInformation.tableHead[1]" align="center"> </el-table-column>
              <el-table-column :prop="`${currentLang.prefix}peoplenum`" :label="recruitmentInformation.tableHead[2]" align="center"> </el-table-column>
              <el-table-column :prop="`${currentLang.prefix}experience`" :label="recruitmentInformation.tableHead[3]" align="center"> </el-table-column>
              <el-table-column :prop="`${currentLang.prefix}educational`" :label="recruitmentInformation.tableHead[4]" align="center"> </el-table-column>
              <!-- <el-table-column prop="address" :label="recruitmentInformation.tableHead[5]" align="center"> </el-table-column> -->
              <el-table-column :label="recruitmentInformation.tableHead[6]" width="90" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleMore(scope.row)" style="color:#06367B;">{{recruitmentInformation.tableActionBtn[0]}}></el-button>
                </template>
              </el-table-column>
            </el-table>

          </div>
          <div class="area_every">
            <div class="area_li">
              <div class="li_left">
                <div class="left_box">
                  <h2>{{ recruitmentInformation.list[0].title }}</h2>
                  <p>
                    {{ recruitmentInformation.list[0].content }}
                  </p>
                  <div class="dynamic_btn" @click="toshiguang">
                    <span>MORE</span>
                    <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
                  </div>
                </div>
              </div>
              <img src="../../assets/images/joinln/working.jpg" alt="">
            </div>
            <div class="area_li">
              <img src="../../assets/images1/i37.jpg" alt="">
              <div class="li_right">
                <h2>{{ recruitmentInformation.list[1].title }}</h2>
                <p>
                  {{ recruitmentInformation.list[1].content }}
                </p>
                <div class="dynamic_btn" @click="toshixi">
                  <span>MORE</span>
                  <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
                </div>
              </div>
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane :label="joinInPage.tabs[2]" name="3">
          <div class="zp_wrap">
            <h2>{{ workingHours.title }}</h2>
            <div v-html="$convertPxToRem(workingHours.content)"></div>
              <div style="height:1px;background: #D7D7D7;width: 100%;margin-top: 80px;"></div>
            <div class="xz_li">
              <div class="left_box">
                <img src="../../assets/images1/i41.png" alt="">
              </div>
              <div class="xz_right">
                <h2>{{ workingHours.group.title }}</h2>
                <p>
                  {{ workingHours.group.content }}
                </p>
                <ul>
                  <li v-for="(item, index) in workingHours.group.list" :key="index">
                    <div class="menu_single"></div>
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="sg_two">
            <div>
              <h2>{{ workingHours.callMe.title }}</h2>
              <p>{{ workingHours.callMe.contentOne }}</p>
              <p>{{ workingHours.callMe.contentTwo }}</p>
              <p>{{ workingHours.callMe.contentThree }}</p>
            </div>
          </div>
          <div class="xy_foot">
            <div class="left_box">
              <img src="../../assets/images1/i40.png" alt="">
            </div>
            <div class="r_box">
              <div class="xz_right">
                <h2>{{ workingHours.group1.title }}</h2>
                <ul>
                  <li v-for="(item, index) in workingHours.group1.list" :key="index">
                    <div class="menu_single"></div>
                    {{ item }}
                  </li>
                </ul>
              </div>
              <div class="xz_right" style="margin-top: 40px;">
                <h2>{{ workingHours.group2.title }}</h2>
                <ul>
                  <li v-for="(item, index) in workingHours.group2.list" :key="index">
                    <div class="menu_single"></div>
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="join_us">
            <div class="join_text" v-html="$convertPxToRem(workingHours.footContent)"></div>
            <div class="join_us_bg">
              <div class="join_us_bg-mask"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="joinInPage.tabs[1]" name="2">
          <div class="zp_wrap">
            <h2>{{ campusInternship.title }}</h2>
            <div v-html="$convertPxToRem(campusInternship.content)"></div>
            <div class="xz_li">
              <div class="left_box">
                <img src="../../assets/images1/i38.png" alt="">
              </div>
              <div class="xz_right">
                <h2>{{ campusInternship.titleOne }}</h2>
                <p>
                  {{ campusInternship.contentOne }}
                </p>
                <ul>
                  <li v-for="(item, index) in campusInternship.listOne" :key="index">
                    <div class="menu_single"></div>
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="sy_two">
            <div>
              <h2>{{ campusInternship.callMe.title }}</h2>
              <p>{{ campusInternship.callMe.contentOne }}</p>
              <p>{{ campusInternship.callMe.contentTwo }}</p>
              <p>{{ campusInternship.callMe.contentThree }}</p>
            </div>
          </div>
          <div class="xy_foot">
            <div class="left_box">
              <img src="../../assets/images1/i40.png" alt="">
            </div>
            <div class="r_box">
              <div class="xz_right">
                <h2>{{ campusInternship.group1.title }}</h2>
                <ul>
                  <li v-for="(item, index) in campusInternship.group1.list" :key="index">
                    <div class="menu_single"></div>
                    {{ item }}
                  </li>
                </ul>
              </div>
              <div class="xz_right" style="margin-top: 40px;">
                <h2>{{ campusInternship.group2.title }}</h2>
                <ul>
                  <li v-for="(item, index) in campusInternship.group2.list" :key="index">
                    <div class="menu_single"></div>
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="join_us">
            <div class="join_text" v-html="$convertPxToRem(campusInternship.footContent)"></div>
            <div class="join_us_bg">
              <div class="join_us_bg-mask"></div>
            </div>
          </div>
        </el-tab-pane>
        
        <el-tab-pane :label="joinInPage.tabs[3]" name="4">
          <div class="zp_wrap">
            <h2>{{ jobSearchProblem.title }}</h2>
            <div v-html="$convertPxToRem(jobSearchProblem.content)"></div>
            </div>  
            <div class="qz_two">
            <div>
              <h2>{{ jobSearchProblem.callMe.title }}</h2>
              <p>{{ jobSearchProblem.callMe.contentOne }}</p>
              <p>{{ jobSearchProblem.callMe.contentTwo }}</p>
              <p>{{ jobSearchProblem.callMe.contentThree }}</p>
            </div>
          </div>
          <div class="qz_foot">
            <h3>{{ jobSearchProblem.zhaoPing.title }}</h3>
            <h4 @click="toZhaopin" style="cursor: pointer;">{{ jobSearchProblem.zhaoPing.content }}</h4>
            <ul>
              <li v-for="item in jobSearchProblem.group" :key="item.id">
                <h3>{{ item.title }}</h3>
                <p style="margin-top: 10px;">{{item.con}}</p>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        
      </el-tabs>
    </div>
    <footer-wrap></footer-wrap>
    <el-dialog :title="recruitmentInformation.dialog.title" :visible.sync="open" width="800px" append-to-body>
      <div class="recruitment-dialog">
        <p v-html="$convertPxToRem(record[`${currentLang.prefix}content`])"></p>
        <div class="sq_btn" @click="toCallMe">
          <span>{{ recruitmentInformation.dialog.btn }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
    
<script>
import { mapGetters } from 'vuex'
import { getZhaoPingList } from '@/utils/http'


export default {
  inject: ['reload'],

  data() {
    return {
      activeName: "1",
      activeNameText: "",
      tableData: [],
      open: false,
      record: {}
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    joinInPage() {
      return this.currentLang.config.joinInPage
    },
    navbar() {
      return this.currentLang.config.navbar
    },
    recruitmentInformation() {
      return this.currentLang.config.joinInPage.recruitmentInformation
    },
    campusInternship() {
      return this.currentLang.config.joinInPage.campusInternship
    },
    workingHours() {
      return this.currentLang.config.joinInPage.workingHours
    },
    jobSearchProblem() {
      return this.currentLang.config.joinInPage.jobSearchProblem
    },
  },

  created() {
    this.activeNameText = this.joinInPage.tabs[0]

    if (this.$route.query.index) {
      this.activeName = this.$route.query.index
      this.setNavActiveNameText(this.activeName)
    }

    this.fetchZhaopingList()
  },

  mounted() {
    
  },

  methods: {
    fetchZhaopingList() {
      getZhaoPingList({ page: 1, limit: 100 }).then(res => {
        if (res.code == 1) {
          this.tableData = res.data
        }
      })
    },

    setNavActiveNameText(active) {
      const { tabs } = this.joinInPage
      switch(active) {
        case '1': this.activeNameText = tabs[0];break;
        case '2': this.activeNameText = tabs[1];break;
        case '3': this.activeNameText = tabs[2];break;
        case '4': this.activeNameText = tabs[3];break;
      }
    },

    onBack() {
      this.$router.push({ path: '/joinIn' })
      this.reload()
    },

    handleClick(tab) {
      this.activeNameText = tab && tab.label ? tab.label : this.activeNameText;
      this.$router.push({
        path: '/joinIn',
        query: {
          index: this.activeName
        }
      })
      this.reload();
    },
    goNdetail() {
      this.$router.push('nText')
    },
    handleMore(row) {
      this.record = row
      this.open = true
    },
    toCallMe(){
	    this.open = false;
	    this.activeName="4";
      this.handleClick();
      // this.$router.push('/callMe')
    },
    toshiguang(){
      this.activeName = '3'
    this.handleClick();
    },
    toshixi(){
      this.activeName = '2'
    this.handleClick();
    },
    toZhaopin(){
      this.$router.push({ path: '/joinIn' })
      this.reload()
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
}	
.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
  }
  .breadcrumb_wrap {
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}

.area_cation {
  min-height: 50vh;
  display: flex;
  justify-content: center;
  /deep/ .el-tabs {
    width: 100%;
    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;
        .el-tabs__nav-scroll {
          height: 100%;
          .el-tabs__nav {
            height: 100%;
            border: 0;
            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }
            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}

.sc_pagi {
  width: 500px;
  margin: auto;
}

.zp_wrap {
  width: 1200px;
  height: auto;
  margin: 50px auto;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  div {
    color: #777777;
    line-height: 1.8;
    font-size: 18px;
  }
}

.sq_btn {
  width: 140px;
  height: 40px;
  line-height: 40px;
  background: #e8363e;
  color: #fff;
  text-align: center;
  border-radius: 20px;
  margin: 50px auto 0 auto;
  cursor: pointer;
  text-indent: 0em;
}

.area_every {
  width: 100%;
  height: auto;
  background: #F5F5F5;
}

.area_li {
  display: flex;
  height: 500px;
  height: 520px;

  img {
    width: 50%;
    object-fit: cover;
    object-position: center;
  }

  .li_right {
    width: 50%;
    background: #F5F5F5;
    // padding: 0 50px;

    h2 {
      color: #003258;
      font-weight: normal;
      margin: 110px 0 30px 110px;
      font-size: 30px;
    }

    p {
      width: 500px;
      color: #777777;
      line-height: 1.8;
      margin-left: 110px;
    }

    .dynamic_btn {
      width: 140px;
      height: 45px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin: 40px 0 0 110px;
      cursor: pointer;

      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }

  .li_left {
    width: 50%;
    background: #F5F5F5;

    .left_box {
      float: right;
      margin-right: 110px;
    }

    h2 {
      color: #003258;
      font-weight: normal;
      margin: 110px 0 30px 0;
      font-size: 30px;
    }

    p {
      width: 500px;
      color: #777777;
      line-height: 1.8;
    }

    .dynamic_btn {
      width: 140px;
      height: 45px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin: 40px 0 0 0;
      cursor: pointer;
      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }
}

.xz_li {
  display: flex;
  width: 1200px;
  margin: 80px auto;

  .left_box {
    width: 50%;

    img {
      width: 250px;
      height: 250px;
      margin: auto;
    }
  }

  .xz_right {
    width: 50%;
    text-align: left;
   

    h2 {
      color: #0B519F;
      font-weight: normal;
    }

    li {
      display: flex;
      align-items: center;
      color: #545454;
      height: 30px;

      .menu_single {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        margin-right: 10px;
        background: #545454;
      }
    }
  }
}


.sy_two {
  width: 100%;
  height: auto;
  background: url('../../assets/images1/i39.jpg') no-repeat;
  background-size: cover;
  background-position: center center;
  margin-top: 50px;
  padding: 110px 0;

  div {
    width: 1200px;
    height: auto;
    background: white;
    margin: 0 auto;
    text-align: center;
    padding: 50px 0;

    h2 {
      color: #0B519F;
      font-weight: normal;
      margin-bottom: 30px;
      font-size: 30px;
    }

    p {
      width: 90%;
      margin: auto;
      color: #545454;
      line-height: 200%;
    }
  }
}

.xy_foot {
  display: flex;
  width: 1200px;
  margin: 80px auto;

  .left_box {
    width: 50%;

    img {
      width: 424px;
      height: 424px;
      margin: auto;
    }
  }

  .r_box {
    width: 50%;
    padding-top: 20px;

    .xz_right {
      width: 100%;
      text-align: left;

      h2 {
        color: #0B519F;
        font-weight: normal;
        margin-bottom: 10px;
      }

      li {
        display: flex;
        align-items: center;
        color: #545454;
        height: 30px;
        .menu_single {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          margin-right: 10px;
          background: #545454;
        }
      }
    }
  }
}

.join_us {
  position: relative;
  width: 100%;
  height: auto;
  padding: 50px 0;
  background: #003359;

  .join_text {
    position: relative;
    z-index: 10;
    width: 1200px;
    color: #FFF;
    text-align: center;
    margin: auto;
    line-height: 200%;
    span {
      color: #1F8AC5;
      border-bottom: 1px solid #1F8AC5;
    }
  }

  .join_us_bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url('../../assets/images/joinln/i1001.png') no-repeat;
    background-size: 100%;
    background-position: center;
    z-index: 0;
  }

  .join_us_bg-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--main-color-blue);
    opacity: 0.85;
  }
}
.sg_two {
  width: 100%;
  height: auto;
  background: url('../../assets/images1/i42.jpg') no-repeat;
  background-size: cover;
  background-position: center center;
  margin-top: 50px;
  padding: 50px 0 90px 0;

  div {
    width: 1200px;
    height: auto;
    background: white;
    margin: 0 auto;
    text-align: center;
    padding: 40px 0;

    h2 {
      color: #0B519F;
      font-weight: normal;
      margin-bottom: 20px;
      font-size: 30px;
    }

    p {
      width: 90%;
      margin: auto;
      color: #545454;
      line-height: 200%;
    }
  }
}
.qz_two{
  width: 100%;
  height: auto;
  background: url('../../assets/images1/i43.jpg') no-repeat;
  background-size: cover;
  background-position: center center; 
  margin-top: 50px;
  padding: 50px 0 70px 0;
  div {
    width: 1200px;
    height: auto;  
    background: white;
    margin: 0 auto;
    text-align: center;
    padding: 40px 0;

    h2 {
      color: #0B519F;
      font-weight: normal;
      margin-bottom: 20px;
      font-size: 30px;
    }

    p {
      width: 90%;
      margin: auto;
      color: #545454;
      line-height: 200%;
    }
  }
}
.qz_foot{
  width: 1000px;
  margin: 80px auto;
  h3,h4{
    font-weight: normal;
  }
  h3{
    color: #0F335E;
  }
  h4{
    color: #545454;
    margin-bottom: 30px;
    margin-top: 10px;
  }
  ul{
    li{
      width: 100%;
      height: auto;
      padding: 20px 0;
      color: #545454;
      border-top: 1px solid #D7D7D7;
    }
  }
}





.el-tabs__nav-wrap {
  margin-bottom: 0;
}

.el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: 0;

}

.el-tabs--card>.el-tabs__header {
  border: 0;
  width: 670px;
  margin: auto;
}

.el-tabs--card>.el-tabs__header .el-tabs__item {
  border-left: 0;
  border-bottom: 0;
}

.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  background: #646464;
}

.el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2) {
  padding-left: 50px;
}

.el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child {
  padding-right: 50px;
}

.el-tabs__item {
  height: 40px;
  color: gray;
  padding: 0 50px;
}

.el-tabs__item.is-active {
  color: white;
}

.el-tabs__nav-wrap {
  height: 40px;
}

.el-tabs__item:hover {
  color: gray;
}

.el-tabs--card>.el-tabs__header .el-tabs__item.is-active:hover {
  color: white;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #e8363e;
}

/deep/ .el-table {
  font-size: 16px;
}
/deep/ .el-table thead {
  color: white;
  font-size: 18px
}

/deep/ .el-table th.el-table__cell {
  background: #003359;
}


.recruitment-dialog {
  font-size: 16px;
  line-height: 1.8;
  text-indent: 2rem;
  color: #666;
}
</style>
    


// WEBPACK FOOTER //
// src/pages/joinIn/joinIn.vue